import type { PersistedBooking } from "schemas";
import { apiRequest } from "../apiRequest";

export async function cancelBooking(booking: PersistedBooking): Promise<void> {
  await apiRequest({ url: `bookings/${booking.id}/cancel`, method: "PATCH" });
}
